/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoAppleIcon16Light } from './LogoAppleIcon16Light';
import { LogoAppleIcon16Regular } from './LogoAppleIcon16Regular';
import { LogoAppleIcon16Solid } from './LogoAppleIcon16Solid';
import { LogoAppleIcon20Light } from './LogoAppleIcon20Light';
import { LogoAppleIcon20Regular } from './LogoAppleIcon20Regular';
import { LogoAppleIcon20Solid } from './LogoAppleIcon20Solid';
import { LogoAppleIcon24Regular } from './LogoAppleIcon24Regular';
import { LogoAppleIcon24Solid } from './LogoAppleIcon24Solid';
import { LogoAppleIcon32Regular } from './LogoAppleIcon32Regular';
import { LogoAppleIcon64Regular } from './LogoAppleIcon64Regular';
var sizes = {
    16: {
        light: LogoAppleIcon16Light,
        regular: LogoAppleIcon16Regular,
        solid: LogoAppleIcon16Solid,
    },
    20: {
        light: LogoAppleIcon20Light,
        regular: LogoAppleIcon20Regular,
        solid: LogoAppleIcon20Solid,
    },
    24: {
        regular: LogoAppleIcon24Regular,
        solid: LogoAppleIcon24Solid,
    },
    32: {
        regular: LogoAppleIcon32Regular,
    },
    64: {
        regular: LogoAppleIcon64Regular,
    },
};
export var LogoAppleIcon = forwardRef('LogoAppleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
